import { FC, useEffect } from "react";

import { realtimeClient } from "services/realtime/client";

import { TOKEN_KEY } from "utils/constants";
import { CookieHelper } from "utils/helpers";

const RealtimeProvider: FC = () => {
  const token = CookieHelper.getCookie(TOKEN_KEY);

  useEffect(() => {
    if (!token) return undefined;

    realtimeClient.start(token);
    return () => realtimeClient.stop();
  }, [token]);

  useEffect(() => {
    const handleVisibility = () => realtimeClient.setHidden(document.visibilityState === "hidden");

    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, []);

  return null;
};

export default RealtimeProvider;
